/** Render body text with lightweight *asterisk* emphasis as italic <em>.
 *
 * Used for Latin species names (e.g. "*Unio crassus*") that live inside
 * config- and catalogue-driven strings, where a structured field isn't
 * available. Text without asterisks passes through unchanged, so this is safe
 * to apply at any render site.
 */

import type { ReactNode } from "react";

const EMPHASIS = /\*([^*]+)\*/g;

export function renderEmphasis(text: string): ReactNode[] {
  const parts: ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;
  let match: RegExpExecArray | null;

  EMPHASIS.lastIndex = 0;
  while ((match = EMPHASIS.exec(text)) !== null) {
    if (match.index > lastIndex) parts.push(text.slice(lastIndex, match.index));
    parts.push(
      <em key={key++} className="italic">
        {match[1]}
      </em>,
    );
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts;
}
